import { useState } from "react";

interface Member {
  mail: string;
  id: string;
  status: number;
}

export const useShareAccounytGroupStates = () => {
  const [ownerMembers, setOwnerMembers] = useState<Member[]>([]);
  const [shareMembers, setShareMembers] = useState<Member[]>([]);
  const [invitedMembers, setInvitedMembers] = useState<Member[]>([]);
  const [check, setCheck] = useState(false);
  const [invitationMail, setInvitationMail] = useState("");
  const [invitationComment, setInvitationComment] = useState("");
  const [isActiveTerminateButton, setIsActiveTerminateButton] = useState(false);
  const [isActiveInviteButton, setIsActiveInviteButton] = useState(false);
  
  // エラーダイアログ表示フラグ情報
  const [isShowErrorDialog, setIsShowErrorDialog] = useState({
    isError: false,
    errorMessage: "",
    errorCode: "",
  });

  return {
    ownerMembers,
    setOwnerMembers,
    shareMembers,
    setShareMembers,
    invitedMembers,
    setInvitedMembers,
    check,
    setCheck,
    invitationMail,
    setInvitationMail,
    invitationComment,
    setInvitationComment,
    isActiveTerminateButton,
    setIsActiveTerminateButton,
    isActiveInviteButton,
    setIsActiveInviteButton,
    isShowErrorDialog,
    setIsShowErrorDialog,
  };
};